import Nav from 'components/Nav';
import Spacer from 'components/Spacer';
import Footer from 'components/Footer';

import AnniversaryInfo from 'components/Anniversary/AnniversaryInfo';
import Timeline from 'components/Anniversary/Timeline';

const navLinks = [
  { text: 'Our Customers', href: '#customers' },
  { text: 'Why MetLife', href: '#why' },
  { text: 'Requirements', href: '#requirements' },
  { text: 'About Us', href: '/about-us' },
];

const AnniversaryTimeline = () => (
  <>
    <Nav links={navLinks} />
    <main role="main" style={{ overflow: 'hidden' }}>
      <Spacer v={32} />
      <AnniversaryInfo />
      <Timeline />
    </main>
    <Footer />
  </>
);

export default AnniversaryTimeline;
